// extracted by mini-css-extract-plugin
export var container = "_co-0";
export var containerTopRight = "_co-1";